import styled from 'styled-components'

const Box = styled.div`
  color: var(--theme-colors-global-general-secondary);
  background-color: var(--theme-colors-global-general-main);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`

const Img = styled.div`
  margin-bottom: 32px;
`

const Title = styled.h2`
  margin-bottom: 16px;
`

const SubTitle = styled.p`
  margin-bottom: 28px;
  font-size: 16px;
`

export const s = { Box, Img, Title, SubTitle }
